/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paywall_Expiring_Soon_TitleInputs */

const en_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus benefits
<span style="color:#2AFD00;">expire soon</span>`)
};

const ar_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مزاياك في Plus
<span style="color:#2AFD00;">ستنتهي قريبًا</span>`)
};

const de_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Plus-Vorteile
<span style="color:#2AFD00;">laufen bald ab</span>`)
};

const es_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus beneficios Plus
<span style="color:#2AFD00;">vencen pronto</span>`)
};

const fr_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes avantages Plus
<span style="color:#2AFD00;">expirent bientôt</span>`)
};

const it_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi vantaggi Plus
<span style="color:#2AFD00;">scadono a breve</span>`)
};

const ja_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus特典の有効期限が
<span style="color:#2AFD00;">まもなく切れます</span>`)
};

const ko_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 혜택이
<span style="color:#2AFD00;">곧 만료돼요</span>`)
};

const pt_br_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus benefícios Plus
<span style="color:#2AFD00;">expiram em breve</span>`)
};

const ru_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Твои преимущества Plus
<span style="color:#2AFD00;">скоро закончатся</span>`)
};

const th_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิทธิประโยชน์ Plus ของคุณ
<span style="color:#2AFD00;">ใกล้หมดอายุแล้ว</span>`)
};

const tr_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus avantajların
<span style="color:#2AFD00;">yakında sona eriyor</span>`)
};

const zh_cn_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 Plus 权益
<span style="color:#2AFD00;">即将到期</span>`)
};

const zh_tw_paywall_expiring_soon_title = /** @type {(inputs: Paywall_Expiring_Soon_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 Plus 權益
<span style="color:#2AFD00;">即將到期</span>`)
};

/**
* | output |
* | --- |
* | "Your Plus benefits <span style=\"color:#2AFD00;\">expire soon</span>" |
*
* @param {Paywall_Expiring_Soon_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const paywall_expiring_soon_title = /** @type {((inputs?: Paywall_Expiring_Soon_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paywall_Expiring_Soon_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_paywall_expiring_soon_title(inputs)
	if (locale === "ar") return ar_paywall_expiring_soon_title(inputs)
	if (locale === "de") return de_paywall_expiring_soon_title(inputs)
	if (locale === "es") return es_paywall_expiring_soon_title(inputs)
	if (locale === "fr") return fr_paywall_expiring_soon_title(inputs)
	if (locale === "it") return it_paywall_expiring_soon_title(inputs)
	if (locale === "ja") return ja_paywall_expiring_soon_title(inputs)
	if (locale === "ko") return ko_paywall_expiring_soon_title(inputs)
	if (locale === "pt_br") return pt_br_paywall_expiring_soon_title(inputs)
	if (locale === "ru") return ru_paywall_expiring_soon_title(inputs)
	if (locale === "th") return th_paywall_expiring_soon_title(inputs)
	if (locale === "tr") return tr_paywall_expiring_soon_title(inputs)
	if (locale === "zh_cn") return zh_cn_paywall_expiring_soon_title(inputs)
	return zh_tw_paywall_expiring_soon_title(inputs)
});